module.exports = __webpack_public_path__ + "img/vue.72e92b7f.svg";